var App = App || {};

App.SectionTabs = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            selector.each(function () {
                const section = $(this);
                const select = section.find(".form-select");

                select.on("change", function () {
                    const activeTab = section.find(`[data-bs-target=\"${$(this).val()}\"]`);
                    activeTab.tab("show");
                });

                section.on("shown.bs.tab", function (e) {
                    const activeTab = section.find("[data-bs-toggle=\"tab\"].active").attr("data-bs-target");
                    select.val(activeTab);
                });
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);